import { render, staticRenderFns } from "./viewImportedAdminData.vue?vue&type=template&id=b12e949c&scoped=true&"
import script from "./viewImportedAdminData.vue?vue&type=script&lang=js&"
export * from "./viewImportedAdminData.vue?vue&type=script&lang=js&"
import style0 from "./viewImportedAdminData.vue?vue&type=style&index=0&id=b12e949c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12e949c",
  null
  
)

export default component.exports